import ReviewTemplateMenu from './ReviewTemplateMenu';

export default ReviewTemplateMenu;
